<template>
  <validation-observer
      ref="saveFormRef"
      #default="{invalid}"
  >
    <b-overlay
        :show="isLoading"
        rounded="sm"
    >
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-form-group label-for="file-title">
              <template v-slot:label>
                Tên hồ sơ <span class="text-danger">*</span>
              </template>
              <validation-provider
                  #default="{ errors }"
                  name="Tên hồ sơ"
                  rules="required"
              >
                <b-form-input
                    id="file-title"
                    v-model="fileTitle"
                    name="fileTitle"
                    placeholder="Tên hồ sơ"
                    :state="getElementState(errors)"
                    aria-describedby="input-1-live-feedback"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
                label-for="file"
            >
              <template v-slot:label>
                File hồ sơ <span class="text-danger">*</span>
              </template>
              <b-form-file
                  ref="inputFileRef"
                  :placeholder="placeholder"
                  @change="uploadFile"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <div class="float-left">
              <b-button
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  :disabled="invalid"
                  @click="handleSaveData"
              >
                Lưu
              </b-button>
            </div>

          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
  </validation-observer>
</template>

<script>
import {
  BForm,
  BButton,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormFile,
  BOverlay,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import api from "./api";
export default {
  name: 'StudentFileSave',
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormFile,
    BOverlay,
  },
  props: {
    dataSendForm: {
      type: Object,
      default: () => ({
        id: null,
        rowNum: null,
        name: '',
        mediaId: null,
        mediaName: '',
        url: '',
        vgt_id: 0,
        originalIndex: 0,
      }),
    },
    modalShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      fileTitle: '',
      fileName: '',
      mediaIds: [],
      nameFile: null,
      placeholder: 'Chọn file để tải hồ sơ...',
      required,
    }
  },
  computed: {
    isCreated() {
      return !this.dataSendForm.id
    },
  },
  created() {
    if (!this.isCreated) {
      this.fileTitle = this.dataSendForm.name
      this.placeholder = this.dataSendForm.mediaName
      this.mediaIds = [this.dataSendForm.mediaId]
    }
  },
  methods: {
    // ...mapActions({
    //   uploadStudentFile: 'studentClass/uploadFile',
    //   saveFile: 'studentClass/saveFile',
    //   updateFile: 'studentClass/updateFile',
    // }),
    // handle even
    async handleSaveData(e) {
      e.preventDefault()
      if (this.mediaIds.length > 0) {
        const param = {
          id: this.dataSendForm.id,
          mediaId: this.mediaIds[0] ? this.mediaIds[0] : this.dataSendForm.mediaId,
          name: this.fileTitle,
          studentId: this.dataSendForm.studentId,
          status: 1,
          delFlag: 0,
        }
        const res = this.isCreated
            ? await api.saveFile(param)
            : await api.updateFile(param)
        const { isSuccessful, message } = res
        if (isSuccessful) {
          this.showToast(message, 'CheckIcon', 'success')
          this.$emit('saveDataSuccess', true)
        } else {
          this.showToast('Có lỗi xẩy ra', 'XCircleIcon', 'error')
        }
      } else {
        this.showToast('Vui lòng chọn file', 'XCircleIcon', 'danger')
      }
    },

    async uploadFile(e) {
      this.isLoading = true
      const formData = new FormData()
      const { files } = e.target
      if (files.length === 0) {
        this.showToast('File đang bị trống', 'InfoIcon', 'warning')
        this.isLoading = false
        return
      }
      files.forEach(file => formData.append('files', file))
      try {
        this.mediaIds = await api.uploadStudentFile(formData)
        this.showToast('Upload file thành công', 'CheckIcon', 'success')
      } catch (error) {
        this.showToast(`[${error.code}] ${error.message}]`, 'XCircleIcon', 'danger')
        this.mediaIds = []
      } finally {
        this.isLoading = false
      }
    },

    showToast(title, icon, variant) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon,
          variant,
        },
      })
    },
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
  },
}
</script>

<style scoped>

</style>
